import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, vShow as _vShow, withDirectives as _withDirectives, unref as _unref, withCtx as _withCtx, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { id: "aside" }

import {reactive, ref, watch} from "vue";
import {useNavigationStore} from "@/modules/Navigation/store";
import {storeToRefs} from "pinia";
import SogSkeleton from "@/shared/ui/SogSkeleton.vue";
import VehicleRegistration from "@/shared/model/VehicleRegistration";
import apiVehicleRegistration from "@/modules/VehicleRegistration/api";
import VehicleRegistrationComponent
  from "@/modules/VehicleRegistration/components/VehicleRegistrationFullComponent.vue";
import SogCard from "@/shared/ui/SogCard.vue";
import SogCardContent from "@/shared/ui/SogCardContent.vue";
import SogCardActions from "@/shared/ui/SogCardActions.vue";
import SogCardActionButton from "@/shared/ui/SogCardActionButton.vue";
import HistoryListComponent from "@/modules/History/components/HistoryListComponent.vue";
import SogCardTitle from "@/shared/ui/SogCardTitle.vue";
import apiHistory from "@/modules/History/api";
import History from "@/shared/model/History";
import GdvMessageIdComponent from "@/modules/VehicleRegistration/components/GdvMessageIdComponent.vue";
import SogFlexColumn from "@/shared/ui/SogFlexColumn.vue";
import getGuid from "@/shared/utils/getGuid";
import {SogDialogButtons} from "@/shared/ui/types/SogDialogButtons";
import SogDialog from "@/shared/ui/SogDialog.vue";
import notificationService from "@/shared/services/NotificationService";
import SogTextBox from "@/shared/ui/SogTextBox.vue";
import VehicleRegistrationLinkDialog
  from "@/modules/VehicleRegistration/components/VehicleRegistrationLinkDialog.vue";
import MemoComponent from "@/modules/VehicleRegistration/components/MemoComponent.vue";
import {IdType} from "@/shared/model/idType";
import apiFileUtils from "@/modules/FileUtils/api";
import ListFile from "@/shared/model/ListFile";
import FileCardComponent from "@/modules/FileUtils/components/FileCardComponent.vue";
import apiFile from "@/shared/services/apiFile";
import {useSpinner} from "@/shared/composables/SogSpinner";


export default /*@__PURE__*/_defineComponent({
  __name: 'VehicleRegistrationSideComponent',
  setup(__props) {


const _navigationStore = useNavigationStore();
const {currentVehicleRegistrationId} = storeToRefs(_navigationStore);
const _vehicleRegistrationId = ref<string>("")
const _loadDetails = ref(true)
const _loadHistory = ref(true)
const _loadFiles = ref(true)
const _history: History[] = reactive<History[]>([])
const _gdvMessageIds = ref<string[]>([])
const _memos = ref<string>("")
const _key = ref<string>("")
const _reason = ref<string>("")
const _vehicleRegistration = ref<VehicleRegistration>(new VehicleRegistration())
const _dialogLink = ref<InstanceType<typeof VehicleRegistrationLinkDialog> | null>(null)
const _dialogIgnore = ref<InstanceType<typeof SogDialog> | null>(null)
const _dialogUnlink = ref<InstanceType<typeof SogDialog> | null>(null)
const _files = ref<ListFile[]>([])
const _spinner = useSpinner("aside")


watch(currentVehicleRegistrationId, async () => {
  if (!currentVehicleRegistrationId.value) {
    return
  }
  if (currentVehicleRegistrationId.value === _vehicleRegistrationId.value) {
    return;
  }

  _vehicleRegistrationId.value = currentVehicleRegistrationId.value
  await load()
})

async function load() {
  if (!currentVehicleRegistrationId) {
    return
  }
  _vehicleRegistrationId.value = currentVehicleRegistrationId.value ?? '';

  _key.value = getGuid();
  const t_loadDetails = loadDetails(_key.value);
  const t_loadHistory = loadHistory(_key.value);
  const t_loadFiles = loadFiles(_key.value);

  await Promise.allSettled([t_loadDetails, t_loadHistory,t_loadFiles])

}

async function loadDetails(key: string) {
  if (!_vehicleRegistrationId.value)
    return
  _loadDetails.value = true
  const res = await apiVehicleRegistration.load(_vehicleRegistrationId.value)
  if (_key.value !== key) {
    return
  }
  if (res) {
    _vehicleRegistration.value = res.vehicleRegistration
    _gdvMessageIds.value = res?.vehicleRegistration.gdvMessageIds?.split('|').filter(Boolean) ?? []
    _memos.value = res?.vehicleRegistration.memo ?? ""
  }
  _loadDetails.value = false
}

async function loadHistory(key: string) {
  if (!_vehicleRegistrationId.value)
    return
  _loadHistory.value = true
  _history.length = 0
  const lst = await apiHistory.listVehicleRegistration(_vehicleRegistrationId.value)
  if (_key.value !== key) {
    return
  }

  if (lst) {
    _history.push(...lst)
  }
  _loadHistory.value = false
}

async function loadFiles(key: string) {
  if (!_vehicleRegistrationId.value) {
    return;
  }
  try {
    _loadFiles.value = true
    const listFile = await apiFileUtils.listFileStore(_vehicleRegistrationId.value)
    if (_key.value !== key) {
      return
    }
    if (listFile) {
      _files.value = listFile?.sort((a, b) => (a.date && b.date) ? Date.parse(b.date.toString()) - Date.parse(a.date.toString()) : 0) ?? [];
    }
  } finally {
    _loadFiles.value = false
  }
}


async function onDetails() {
  await _navigationStore.showObject(IdType.VehicleRegistration, _vehicleRegistrationId.value);
}

function onOpen(action: string) {
  if (action === "link")
    _dialogLink.value?.show()
  else if (action === "unlink")
    _dialogUnlink.value?.show()
  else
    _dialogIgnore.value?.show()
}

function onCancelLink(action: string) {
  if (action === "unlink") {
    _dialogUnlink.value?.hide()
    _reason.value = ""
  } else {
    _dialogIgnore.value?.hide()
    _reason.value = ""
  }

}

async function onOkUnLink() {

  if (!_reason.value) {
    notificationService.error("Bitte einen Grund eingeben")
    return
  }
  const res = await apiVehicleRegistration.insuranceLink(_vehicleRegistration.value?.id ?? "", _vehicleRegistration.value?.id ?? "", _reason.value, true)
  if (res) {
    notificationService.success("Zulassung erfolgreich unverknüpft")
    _reason.value = ""
    _dialogUnlink.value?.hide()
    await load()

  }
}

async function onOkIgnore() {

  if (!_reason.value) {
    notificationService.error("Bitte einen Grund eingeben")
    return
  }
  const res = await apiVehicleRegistration.ignore(_vehicleRegistration.value?.id ?? "", _reason.value)
  if (res) {
    notificationService.success("Zulassung erfolgreich ignoriert")
    _reason.value = ""
    _dialogIgnore.value?.hide()
    await load()

  }

}


function onPolicy() {
  if (_vehicleRegistration.value.insuranceId) {
    _navigationStore.currentInsuranceId = _vehicleRegistration.value.insuranceId
  }
}

async function onDownload(file: ListFile) {
  if (!file.personId)
    return;
  try {
    _spinner.show()
    const fileId = await apiFileUtils.initDownloadFile(file.id ?? "");
    if (fileId)
      await apiFile.downloadTempFile(fileId)

  } finally {
    _spinner.hide()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(SogFlexColumn, { style: {"align-items":"flex-start"} }, {
      default: _withCtx(() => [
        _createVNode(SogCard, null, {
          default: _withCtx(() => [
            _withDirectives(_createVNode(SogCardActions, null, {
              default: _withCtx(() => [
                _createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-information",
                  tooltip: "Details anzeigen",
                  onClick: onDetails
                }),
                _withDirectives(_createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-shield-link-variant",
                  tooltip: "Verknüpfen",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (onOpen('link')))
                }, null, 512), [
                  [_vShow, !_vehicleRegistration.value?.insuranceId]
                ]),
                _withDirectives(_createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-shield",
                  tooltip: "Versicherungskarte",
                  onClick: onPolicy
                }, null, 512), [
                  [_vShow, _vehicleRegistration.value?.insuranceId]
                ]),
                _withDirectives(_createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-shield-remove",
                  tooltip: "Verknüpfung löschen",
                  onClick: _cache[1] || (_cache[1] = ($event: any) => (onOpen('unlink')))
                }, null, 512), [
                  [_vShow, _vehicleRegistration.value?.insuranceId]
                ]),
                _withDirectives(_createVNode(SogCardActionButton, {
                  "mdi-icon": "mdi-close",
                  tooltip: "Ignorieren",
                  onClick: _cache[2] || (_cache[2] = ($event: any) => (onOpen('ignore')))
                }, null, 512), [
                  [_vShow, _vehicleRegistration.value?.ignore==='Y' || !_vehicleRegistration.value?.insuranceId]
                ]),
                _createVNode(VehicleRegistrationLinkDialog, {
                  ref_key: "_dialogLink",
                  ref: _dialogLink,
                  target: "#aside",
                  "vehicle-registration-id": _vehicleRegistration.value?.id,
                  onLinked: load
                }, null, 8, ["vehicle-registration-id"]),
                _createVNode(SogDialog, {
                  ref_key: "_dialogUnlink",
                  ref: _dialogUnlink,
                  target: "#aside",
                  "dialog-buttons": _unref(SogDialogButtons).OkCancel,
                  onClickOk: onOkUnLink,
                  onClickCancel: _cache[4] || (_cache[4] = ($event: any) => (onCancelLink('unlink')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(SogTextBox, {
                      modelValue: _reason.value,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_reason).value = $event)),
                      width: "100%",
                      multiline: true,
                      placeholder: "Grund fürs Löschen"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["dialog-buttons"]),
                _createVNode(SogDialog, {
                  ref_key: "_dialogIgnore",
                  ref: _dialogIgnore,
                  target: "#aside",
                  "dialog-buttons": _unref(SogDialogButtons).OkCancel,
                  onClickOk: onOkIgnore,
                  onClickCancel: _cache[6] || (_cache[6] = ($event: any) => (onCancelLink('ignore')))
                }, {
                  default: _withCtx(() => [
                    _createVNode(SogTextBox, {
                      modelValue: _reason.value,
                      "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_reason).value = $event)),
                      multiline: true,
                      width: "100%",
                      placeholder: "Grund fürs Ignorieren"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                }, 8, ["dialog-buttons"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_loadDetails.value]
            ]),
            _withDirectives(_createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _createVNode(VehicleRegistrationComponent, { data: _vehicleRegistration.value }, null, 8, ["data"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_loadDetails.value]
            ]),
            _createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                  [_vShow, _loadDetails.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(SogCard, null, {
          default: _withCtx(() => [
            _createVNode(SogCardTitle, null, {
              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                _createTextVNode("Historie", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _createVNode(HistoryListComponent, { data: _history }, null, 8, ["data"])
              ]),
              _: 1
            }, 512), [
              [_vShow, !_loadHistory.value]
            ]),
            _createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                  [_vShow, _loadHistory.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _loadHistory.value || _history.length>0]
        ]),
        _createVNode(SogCard, null, {
          default: _withCtx(() => [
            _createVNode(SogCardTitle, null, {
              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                _createTextVNode("Gdv Nachrichten", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _createVNode(SogFlexColumn, null, {
                  default: _withCtx(() => [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_gdvMessageIds.value, (data, i) => {
                      return (_openBlock(), _createBlock(GdvMessageIdComponent, {
                        key: i,
                        item: data
                      }, null, 8, ["item"]))
                    }), 128))
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, !_loadDetails.value]
            ]),
            _createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                  [_vShow, _loadDetails.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }),
        _withDirectives(_createVNode(SogCard, null, {
          default: _withCtx(() => [
            _createVNode(SogCardTitle, null, {
              default: _withCtx(() => [...(_cache[9] || (_cache[9] = [
                _createTextVNode("Bemerkungen", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _createVNode(SogFlexColumn, null, {
                  default: _withCtx(() => [
                    _createVNode(MemoComponent, { memo: _memos.value }, null, 8, ["memo"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }, 512), [
              [_vShow, !_loadDetails.value]
            ]),
            _createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _withDirectives(_createVNode(SogSkeleton, null, null, 512), [
                  [_vShow, _loadDetails.value]
                ])
              ]),
              _: 1
            })
          ]),
          _: 1
        }, 512), [
          [_vShow, _memos.value]
        ]),
        _withDirectives(_createVNode(SogCard, null, {
          default: _withCtx(() => [
            _createVNode(SogCardTitle, null, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode("Anhänge", -1)
              ]))]),
              _: 1
            }),
            _withDirectives(_createVNode(SogCardContent, null, {
              default: _withCtx(() => [
                _createVNode(SogSkeleton)
              ]),
              _: 1
            }, 512), [
              [_vShow, _loadFiles.value]
            ]),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_files.value, (file) => {
              return _withDirectives((_openBlock(), _createBlock(SogCardContent, {
                key: file.id
              }, {
                default: _withCtx(() => [
                  _createVNode(FileCardComponent, { file: file }, {
                    default: _withCtx(() => [
                      _createVNode(SogCardActionButton, {
                        "mdi-icon": "mdi-download",
                        tooltip: "Download",
                        onClick: ($event: any) => (onDownload(file))
                      }, null, 8, ["onClick"])
                    ]),
                    _: 2
                  }, 1032, ["file"])
                ]),
                _: 2
              }, 1024)), [
                [_vShow, !_loadFiles.value]
              ])
            }), 128))
          ]),
          _: 1
        }, 512), [
          [_vShow, _loadFiles.value || _files.value.length>0]
        ])
      ]),
      _: 1
    })
  ]))
}
}

})